import { render, staticRenderFns } from "./Administration.vue?vue&type=template&id=f89e59b6&"
import script from "./Administration.vue?vue&type=script&lang=js&"
export * from "./Administration.vue?vue&type=script&lang=js&"
import style0 from "./Administration.vue?vue&type=style&index=0&id=f89e59b6&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f89e59b6')) {
      api.createRecord('f89e59b6', component.options)
    } else {
      api.reload('f89e59b6', component.options)
    }
    module.hot.accept("./Administration.vue?vue&type=template&id=f89e59b6&", function () {
      api.rerender('f89e59b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/Administration.vue"
export default component.exports